module.exports = __webpack_public_path__ + "static/media/itineraire_litteraire.78580342.jpg";